import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { handleURLParams } from '../../helpers/URLParams';

class AdminPagination extends PureComponent {
  getPagination() {
    const {
      total,
      page,
      perPage,
    } = this.props;
    const pages = Math.ceil(total / perPage);
    const delta = 3;

    const range = [];
    for (
      let i = Math.max(2, (page - delta));
      i < Math.min(pages, (page + delta));
      i += 1
    ) {
      range.push(i - 1);
    }

    if ((page - delta) > 2) {
      range.unshift(-2);
    }
    if ((page + delta) < (pages - 1)) {
      range.push(-3);
    }

    range.unshift(0);
    if (pages !== 1) {
      range.push(pages - 1);
    }

    return range;
  }

  handlePage(page) {
    const { handleChangePage, history } = this.props;
    handleChangePage(page);
    handleURLParams({ page }, history);
  }

  render() {
    const {
      total,
      page,
      perPage,
    } = this.props;
    const pages = Math.ceil(total / perPage);

    if (pages <= 1) {
      return null;
    }

    return (
      <div className="table-pagination">
        <div className="pagination">
          {page > 1 ? (
            <a
              href="#previous"
              className="previous"
              onClick={(e) => {
                e.preventDefault();
                this.handlePage(page - 1);
              }}
            >
              <i className="far fa-angle-left" />
            </a>
          ) : (
            <span className="previous">
              <i className="far fa-angle-left" />
            </span>
          )}
          {Array.from(this.getPagination()).map(p => (p + 1)).map(p => (
            p === page ? (
              <span key={p} className="current">
                {p}
              </span>
            ) : (
              <Fragment key={p > 0 ? p : p * -1 + 99999}>
                {p > 0 ? (
                  <a
                    href="#page"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handlePage(p);
                    }}
                  >
                    {p}
                  </a>
                ) : (
                  <span className="current">
                    ...
                  </span>
                )}
              </Fragment>
            )
          ))}
          {page < pages ? (
            <a
              href="#next"
              className="next"
              onClick={(e) => {
                e.preventDefault();
                this.handlePage(page + 1);
              }}
            >
              <i className="far fa-angle-right" />
            </a>
          ) : (
            <span className="next">
              <i className="far fa-angle-right" />
            </span>
          )}
        </div>
      </div>
    );
  }
}

AdminPagination.propTypes = {
  history: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
};

export default withRouter(AdminPagination);
